module.exports = __webpack_public_path__ + "static/img/建筑智能化_中央空调系统3@2x.74c7de4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buliding/建筑智能化_中央空调系统3@2x.png
// module id = 37Jm
// module chunks = 1